import React, { FC } from 'react';
import styles from './WixIcon.scss';

export const WixIcon: FC = () => <div className={styles.wixIcon} />;
